import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use( Vuetify );

export default new Vuetify( {
    rtl : true,
    theme : {
        themes : {
            light : {
                primary : '#075fe5',
                secondary : '#424242',
                accent : '#82B1FF',
                error : '#ed3024',
                info : '#2196F3',
                success : '#4CAF50',
                warning : '#FFC107'
            }
        }
    }
} );